import $ from 'jquery';
import { storageAvailable } from '_utils';
// import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransitionGroup } from 'react-transition-group';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { ReactTableDefaults } from 'react-table';
import ReactLoading from 'react-loading';
import { scrollTo } from '../dom/window';
import classnames from 'classnames';
import ReactTableRowConfirmationModal from './ReactTableRowConfirmationModal';
import { getTranslation } from '../lang/main';
import LocalizedMessage from "react-l10n";

const CustomTbodyComponent = ({ children, className, ...rest }) => {
    return (
        <CSSTransitionGroup
            component='div'
            transitionName='react-table-animate'
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
            className={classnames('rt-tbody', className)}
            {...rest}
        >
            {children}
        </CSSTransitionGroup>
    );
};

const CustomTrGroupComponent = (params) => {
    const {
        key,
        children,
        className,
        row,
        hasRemoveConfirmation,
        onRemoveRow,
        onToggleRemoveConfirmation,
        onRowClick,
        ...rest
    } = params;

    const handleRowClick = (e) => {
        if (typeof onRowClick != 'undefined' && onRowClick) {
            onRowClick(e);
        }
    };

    return (
        <div
            className={classnames('rt-tr-group', className)}
            role='rowgroup'
            {...rest}
            onClick={handleRowClick}
        >
            {children}
            {hasRemoveConfirmation && (
                <ReactTableRowConfirmationModal
                    content={getTranslation('REMOVE_ITEM_FROM_LIST')}
                    confirmText={getTranslation('CONFIRM')}
                    closeText={getTranslation('CLOSE')}
                    onConfirm={() => onRemoveRow(row)}
                    onCancel={() => onToggleRemoveConfirmation(row, false)}
                />
            )}
        </div>
    );
};

class ReactTableHeaderWrapper extends React.Component {
    render() {
        const {
            state,
            hasFilters,
            hasSearch,
            hasDisplay,
            hasGridView,
            blurSearch,
            changeSearch,
            changeSize,
            changeTableView,
        } = this.props;
        const { searchDisplay, perPage, tableView } = state;

        if (!hasSearch && !hasDisplay && !hasGridView) return null;

        return (
            <div className='react-table-header row row--xsmall vspace vspace--small'>
                <div className='row row--small'>
                    <div className='col-xs-12 col-sm-3'>
                        {hasFilters && (
                            <button
                                type='button'
                                className='filter-toggle visible-xs visible-sm visible-md'
                                data-sidebar-toggle='.filters'
                                title={getTranslation('FILTERS')}
                            >
                                <i className='icon icon-filter' />
                                <LocalizedMessage id={'FILTERS'} />
                            </button>
                        )}
                    </div>
                    <div className='col-xs-12 col-sm-9 col-lg-12'>
                        <div className='sort-box'>
                            {hasSearch && (
                                <div className='sort-box__item'>
                                    <div className='react-table-search-form'>
                                        <label className='field'>
                                            <input
                                                type='text'
                                                name='search'
                                                placeholder='Search'
                                                className='field__input'
                                                value={searchDisplay}
                                                onBlur={(e) => blurSearch(e)}
                                                onChange={(e) =>
                                                    changeSearch(e)
                                                }
                                            />
                                        </label>
                                    </div>
                                </div>
                            )}
                            {hasDisplay && (
                                <div className='sort-box__item'>
                                    <label className='field field--select'>
                                        <span className='field__text'>
                                            <LocalizedMessage id={'DISPLAY'} />
                                        </span>
                                        <select
                                            name='display'
                                            className='field__input'
                                            autoComplete='off'
                                            value={perPage}
                                            onChange={(e) => changeSize(e)}
                                        >
                                            {/*<option value="12">12 products</option>*/}
                                            <option value='24'>
                                                24 <LocalizedMessage id={'PRODUCTS'} />
                                            </option>
                                            <option value='48'>
                                                48 <LocalizedMessage id={'PRODUCTS'} />
                                            </option>
                                        </select>
                                    </label>
                                </div>
                            )}
                            {/* <div className="sort-box__item">
                                <label className="field field--select">
                                    <span className="field__text">Sort</span>
                                    <select id="sort-dropdown" name="sort" className="field__input" autoComplete="off" data-filter>
                                        <option value="most-recent">Most Recent</option>
                                        <option value="recommendation">Recommendation</option>
                                        <option value="alphabet-a-z">Alphabetically</option>
                                    </select>
                                </label>
                            </div> */}
                            {hasGridView && (
                                <div className='sort-box__item'>
                                    <div className='field'>
                                        <span className='field__text hidden-xs'>
                                            <LocalizedMessage id={'VIEW'} />
                                        </span>
                                        <button
                                            type='button'
                                            className={`sort-box__button ${tableView ===
                                                'list' &&
                                                ' sort-box__button--active'}`}
                                            title='List'
                                            onClick={() =>
                                                changeTableView('list')
                                            }
                                        >
                                            <i className='icon icon-list' />
                                        </button>
                                        <button
                                            type='button'
                                            className={`sort-box__button ${tableView ===
                                                'grid' &&
                                                ' sort-box__button--active'}`}
                                            title='Grid'
                                            onClick={() =>
                                                changeTableView('grid')
                                            }
                                        >
                                            <i className='icon icon-grid' />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
class ReactTableWrapper extends React.Component {
    constructor(props) {
        super(props);

        const {
            tableView,
            perPage,
            editing,
            hasRemoveConfirmation,
        } = this.props;

        this.state = {
            hasRemoveConfirmation: hasRemoveConfirmation || false,
            expanded: {},
            tabsSelected: {},
            editing: editing || false,
            selection: {},
            selectAll: false,
            tableView: tableView,
            perPage: perPage,
            search: '',
        };
    }
    componentDidMount() {
        const { fetchParams } = this.props;
        const { search } = this.state;
        const { request } = fetchParams || false;
        if (!request) return;
        request({
            search: search, // extra data passed to the callback
        });
    }
    getFilteredData() {
        const { search } = this.state;
        const { filterCallback, data } = this.props;
        let newData = [...data];

        if (filterCallback) {
            return filterCallback(newData, search);
        }
        if (search) {
            newData = newData.filter((row) => {
                return (
                    (row['title'] &&
                        row['title']
                            .toLowerCase()
                            .includes(search.toLowerCase())) ||
                    (row['sku'] &&
                        row['sku']
                            .toLowerCase()
                            .includes(search.toLowerCase())) ||
                    (row['category'] &&
                        row['category']
                            .toLowerCase()
                            .includes(search.toLowerCase()))
                );
            });
        }

        return newData;
    }
    removeItems(newData) {
        const { removeCallback } = this.props;
        removeCallback(newData);
        this.setState({
            expanded: false,
            editing: false,
        });
    }
    handleTabs(updates) {
        const { tabsSelected, expanded } = this.state;
        const { newExpanded, newTabsSelected } = updates;

        this.setState({
            expanded: {
                ...expanded,
                ...newExpanded,
            },
            tabsSelected: {
                ...tabsSelected,
                ...newTabsSelected,
            },
        });
    }
    blurSearch(e) {
        const { initialSearchKeyword, blockLocalSearch } = this.props;
        const { searchDisplay } = this.state;

        if (!searchDisplay && initialSearchKeyword) {
            this.setState({
                expanded: {},
                search: blockLocalSearch ? '' : initialSearchKeyword,
                searchDisplay: initialSearchKeyword,
            });
        }
    }
    changeSearch(e) {
        const { searchCallback, blockLocalSearch } = this.props;
        const searchedInput = e.target.value;

        this.setState({
            expanded: {},
            search: blockLocalSearch ? '' : searchedInput,
            searchDisplay: searchedInput,
        });

        if (searchCallback) {
            return searchCallback({ search: searchedInput });
        }
    }
    changeSize(e) {
        const { value } = e.target;
        const { LS, changePerPageCallback } = this.props;

        if (storageAvailable('localStorage')) {
            LS.set('perPage', Number(value));
        }
        this.setState({
            perPage: Number(value),
        });

        if (changePerPageCallback) {
            return changePerPageCallback(Number(value));
        }
    }
    changeTableView(type) {
        const { LS, changeTableViewCallback } = this.props;
        if (storageAvailable('localStorage')) {
            LS.set('tableView', type);
        }
        this.setState({
            tableView: type,
        });

        if (changeTableViewCallback) {
            return changeTableViewCallback(type);
        }
    }
    toggleEdit() {
        this.setState({
            editing: !this.state.editing,
            selection: {},
            selectAll: false,
        });
    }
    toggleRow(index) {
        const newSelection = { ...this.state.selection };
        newSelection[index] = !newSelection[index];
        this.setState(
            {
                selection: newSelection,
                selectAll: false,
            },
            this.toggleRowCallback
        );
    }
    toggleAllRows() {
        let newSelection = {};
        const filteredData = this.getFilteredData();

        if (!this.state.selectAll) {
            filteredData.map((row) => {
                newSelection[row.id] = true;
            });
        }

        this.setState(
            {
                selection: newSelection,
                selectAll: !this.state.selectAll,
            },
            this.toggleRowCallback
        );
    }
    toggleRowCallback() {
        const { toggleRowCallback } = this.props;
        if (toggleRowCallback) {
            toggleRowCallback(this.getSelectedRows());
        }
    }
    getSelectedRows() {
        return Object.entries(this.state.selection)
            .filter(([key, value]) => value === true)
            .map(([key, value]) => {
                return { id: key };
            });
    }
    toggleRemoveConfirmation(row, value) {
        const { toggleRemoveConfirmation } = this.props;

        if (toggleRemoveConfirmation) {
            toggleRemoveConfirmation(row, value);
        }
    }
    getRemoveConfirmation(row) {
        const { getRemoveConfirmation } = this.props;

        if (getRemoveConfirmation) {
            return getRemoveConfirmation(row);
        }

        return false;
    }
    onRemoveRow(row) {
        const { onRemoveRow } = this.props;

        if (onRemoveRow) {
            onRemoveRow(row);
        }
    }
    getTableProps() {
        const {
            expanded,
            editing,
            hasRemoveConfirmation,
            selectAll,
            selection,
            perPage,
            tableView,
        } = this.state;
        const {
            loading,
            reactTable,
            headerMsg,
            onFetchData,
            onRowClick,
        } = this.props;
        const filteredData = this.getFilteredData();
        let reactTableClassName = 'react-table';

        if (filteredData.length) {
            reactTableClassName += ' react-table--has-data';
        }

        const tablePropsDefault = {
            data: filteredData,
            loading: loading || false,
            className: reactTableClassName,
            previousText: getTranslation('PREV'),
            nextText: getTranslation('NEXT'),
            noDataText: getTranslation('TABLE_NO_ITEMS_FOUND'),
            // rowsText: 'rows',
            minRows: '0',
            showPageSizeOptions: false,
            pageSize: perPage,
            resizable: false,
            expanded: expanded,
            onFetchData: (state, instance) => {
                if (typeof onFetchData != 'undefined' && onFetchData) {
                    return onFetchData(state, instance);
                }

                return null;
            },
            defaultFilterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined
                    ? String(row[id]).includes(filter.value)
                    : true;
            },
            column: {
                ...ReactTableDefaults.column,
                Header: (row) => {
                    return (
                        <span className='react-table__header'>{row.value}</span>
                    );
                },
                Cell: (row) => {
                    return (
                        <span className='react-table__info'>{row.value}</span>
                    );
                },
            },
            onFilteredChange: (filtered, column) => {
                this.setState({
                    expanded: {},
                });
            },
            onPageChange: (pageIndex) => {
                this.setState({
                    expanded: {},
                });

                this.scrollToTop();
            },
            onSortedChange: (newSorted, column, shiftKey) => {
                this.setState({
                    expanded: {},
                });
            },
            onExpandedChange: (newExpanded, index, event) => {
                this.setState({
                    expanded: newExpanded,
                });
            },
            getTheadThProps(state, rowInfo, col, instance) {
                if (col.Header === 'hidden') {
                    return {
                        style: { visibility: 'hidden' },
                    };
                }
                return {};
            },
            getTrGroupProps: (state, row, col, instance) => {
                const { viewIndex } = row;
                const isExpanded =
                    state.expanded &&
                    state.expanded.hasOwnProperty(viewIndex) &&
                    state.expanded[viewIndex];
                const isShowingRemoveConfirmation = this.getRemoveConfirmation(
                    row
                );
                let classes = 'react-table__row';
                classes += ` ${isExpanded ? 'react-table__row--expanded' : ''}`;
                classes += ` ${
                    isShowingRemoveConfirmation
                        ? 'react-table__row--removing'
                        : ''
                }`;

                return {
                    className: classes,
                    row: row,
                    onRemoveRow: (row) => this.onRemoveRow(row),
                    onToggleRemoveConfirmation: (row, value) =>
                        this.toggleRemoveConfirmation(row, value),
                    hasRemoveConfirmation: hasRemoveConfirmation,
                    // key: viewIndex,
                };
            },
            TbodyComponent: CustomTbodyComponent,
            TrGroupComponent: CustomTrGroupComponent,
            NoDataComponent: (params) => {
                if (loading) return null;
                return (
                    <div className='react-table__dataless'>
                        {params.children}
                    </div>
                );
            },
            LoadingComponent: () => {
                if (!loading) return null;
                return (
                    <div className='react-table__loading'>
                        <ReactLoading
                            className='button__spinner'
                            type='spin'
                            color='black'
                            height={50}
                            width={50}
                        />
                    </div>
                );
            },
        };
        const tableProps =
            tableView === 'grid' ? reactTable.grid : reactTable.list;
        const newTableProps = {
            ...tablePropsDefault,
            ...tableProps,
        };
        let newColumns = [...newTableProps.columns];

        // editing
        if (editing) {
            newTableProps.columns = [
                {
                    Header: () => {
                        let fieldClasses = 'field field--checkbox';
                        if (selectAll === true) {
                            fieldClasses = fieldClasses.concat(
                                ' ',
                                'field--checked'
                            );
                        }
                        return (
                            <label className={fieldClasses}>
                                <input
                                    type='checkbox'
                                    className='field__input'
                                    checked={selectAll}
                                    onChange={() => this.toggleAllRows()}
                                />
                            </label>
                        );
                    },
                    Cell: (row) => {
                        let fieldClasses = 'field field--checkbox';
                        if (selection[row.value] === true) {
                            fieldClasses = fieldClasses.concat(
                                ' ',
                                'field--checked'
                            );
                        }
                        return (
                            <label className={fieldClasses}>
                                <input
                                    type='checkbox'
                                    className='field__input'
                                    checked={selection[row.value] === true}
                                    onChange={() => this.toggleRow(row.value)}
                                />
                            </label>
                        );
                    },
                    sortable: false,
                    accessor: 'id',
                    width: 50,
                },
            ].concat(newTableProps.columns);
        }

        // wrap headerMsg on columns
        if (headerMsg) {
            newColumns = newColumns.map((item) => {
                return { ...item, headerClassName: 'hidden' };
            });
            newTableProps.columns = [
                {
                    Header: () => {
                        return (
                            <React.Fragment>
                                <span className='heading heading--lv4'>
                                    {headerMsg}
                                </span>
                            </React.Fragment>
                        );
                    },
                    columns: newColumns,
                },
            ];
        }

        return newTableProps;
    }
    getHeaderProps() {
        const {
            headerProps,
            hasSearch,
            hasDisplay,
            hasFilters,
            hasGridView,
        } = this.props;
        return {
            hasSearch,
            hasDisplay,
            hasGridView,
            hasFilters,
            removeItems: (e) => this.removeItems(e),
            getSelectedRows: () => this.getSelectedRows(),
            toggleEdit: () => this.toggleEdit(),
            blurSearch: (e) => this.blurSearch(e),
            changeSearch: (e) => this.changeSearch(e),
            changeSize: (e) => this.changeSize(e),
            changeTableView: (e) => this.changeTableView(e),
            state: this.state,
            ...headerProps,
        };
    }
    scrollToTop() {
        const node = ReactDOM.findDOMNode(this);
        scrollTo($(node));
    }
    render() {
        // if (!this.props.data.length) return null;
        const {
            data,
            loading,
            DatalessComponent,
            headerComponent,
        } = this.props;
        const HeaderComponent = headerComponent || ReactTableHeaderWrapper;
        const tableProps = this.getTableProps();
        const headerProps = this.getHeaderProps();

        return DatalessComponent && !loading && !data.length ? (
            <DatalessComponent />
        ) : (
            <div className='react-table-container'>
                <HeaderComponent {...headerProps} />
                <ReactTable
                    // key={this.state.perPage}
                    {...tableProps}
                    ref={(r) => (this.table = r)}
                />
            </div>
        );
    }
}

// default props
ReactTableWrapper.defaultProps = {
    perPage: 24,
    tableView: 'list',
};
// validate props
ReactTableWrapper.propTypes = {};

export default ReactTableWrapper;
